export default __webpack_public_path__ + "static/media/Panchami4.c4c11225.png";